import { useEffect, useRef } from 'react';
import { useConsent } from './ConsentProvider';
import { setDefaultConsent, updateConsent, loadGTM } from '@/utils/gtm';
import settings from '@/content/settings.json';

/**
 * Carica GTM (container ID da Impostazioni → Tracciamento) e tiene i suoi
 * segnali di Consent Mode allineati al ConsentProvider. Nessun tag
 * (GA4/Meta/Ads) è configurato qui: si gestiscono su tagmanager.google.com,
 * in autonomia, senza bisogno di toccare il codice — vedi gtm.js per il
 * perché il container si carica sempre a prescindere dal consenso.
 */
export function GoogleTagManager() {
  const { consent } = useConsent();
  const containerId = settings.tracking?.gtmContainerId?.trim();
  const loadedRef = useRef(false);

  useEffect(() => {
    if (!containerId || loadedRef.current) return;
    loadedRef.current = true;
    setDefaultConsent();
    loadGTM(containerId);
  }, [containerId]);

  useEffect(() => {
    if (!containerId) return;
    updateConsent(consent);
  }, [containerId, consent]);

  return null;
}
